import React, { Component } from "react";
import { Link } from "react-router-dom";

class SiteContent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      iconbox: [
        {
          id: 1,
          icon: "autora-icon-quality",
          title: "PREMIUM QUALITY",
          text: "We stock only the finest building materials from trusted manufacturers. Every product meets our strict quality standards to ensure your projects succeed.",
        },
        {
          id: 2,
          icon: "autora-icon-time",
          title: "READY STOCK",
          text: "Large inventory maintained at all times. No waiting for materials - we have what you need when you need it for your construction projects.",
        },
        {
          id: 3,
          icon: "autora-icon-author",
          title: "EXPERT ADVICE",
          text: "Our knowledgeable team provides professional guidance on material selection, quantities, and technical specifications for your specific needs.",
        },
      ],
      history: [
        {
          id: 1,
          content: [
            {
              id: 1,
              year: "2010",
              text: "K.Lizz Classic Hardware was established in Nairobi with a vision to provide quality building materials to the construction industry. We started with a small inventory of plywood and basic hardware supplies.",
              classnames: "flat-content-wrap",
            },
            {
              id: 2,
              year: "2018",
              text: "Expanded our product range to include premium MDF boards, laminated sheets, and a comprehensive selection of doors. Invested in modern cutting equipment to offer custom sizing services.",
              classnames: "flat-content-wrap",
            },
          ],
        },
        {
          id: 2,
          content: [
            {
              id: 3,
              year: "2015",
              text: "Grew our customer base significantly, serving contractors, developers, and homeowners across Nairobi. Established partnerships with leading material manufacturers and brands.",
              classnames: "flat-content-wrap pd26",
            },
            {
              id: 4,
              year: "2024",
              text: "Today, K.Lizz Classic Hardware is a trusted name in Nairobi's hardware industry. With over 5,000+ products in stock and 1,200+ satisfied customers, we continue to flow with qualities.",
              classnames: "flat-content-wrap pd26",
            },
          ],
        },
      ],
      accordions: [
        {
          id: 1,
          classnames: "accordion-item active",
          title: "our mission",
          text: "To be Nairobi's most trusted supplier of premium building materials by maintaining the highest quality standards, providing expert guidance, and ensuring our customers have immediate access to the products they need. We are committed to supporting Kenya's construction industry with reliable materials and exceptional service.",
        },
        {
          id: 2,
          classnames: "accordion-item",
          title: "our vision",
          text: 'To establish K.Lizz Classic Hardware as the leading building materials supplier in Kenya, known for uncompromising quality, comprehensive product range, and customer-first service. We envision expanding our reach while maintaining our core principle: "We Flow With Qualities" in everything we do.',
        },
        {
          id: 3,
          classnames: "accordion-item",
          title: "our values",
          text: "Quality First - We never compromise on material standards. Customer Focus - Your project success is our priority. Integrity - Honest advice and fair pricing always. Innovation - Modern equipment and efficient service. Community - Supporting Nairobi's builders and contractors with reliable supplies and expertise.",
        },
      ],
    };
  }
  render() {
    return (
      <div id="site-content" className="site-content clearfix">
        <div id="inner-content" className="inner-content-wrap">
          <div
            className="themesflat-spacer clearfix"
            data-desktop={61}
            data-mobile={60}
            data-smobile={60}
          />
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">ABOUT K.LIZZ CLASSIC HARDWARE</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
            <p className="sub-heading line-height-24 text-777 margin-top-28 margin-right-12">
              K.Lizz Classic Hardware is Nairobi's premier destination for
              quality building materials and construction supplies. Established
              with a commitment to excellence, we have grown to become a trusted
              partner for contractors, developers, and homeowners throughout
              Kenya. Our extensive inventory includes premium plywood, MDF
              boards, blockboards, doors, hardware supplies, paints, and
              construction materials from leading manufacturers. With our modern
              workshop equipped with precision cutting machinery, we offer
              custom sizing services to meet your exact specifications. Our
              experienced team provides expert consultation to help you select
              the right materials and calculate accurate quantities for your
              projects. At K.Lizz Classic Hardware, we don't just sell materials
              - we build lasting relationships based on quality, reliability,
              and exceptional service. Visit us in Nairobi and experience why
              our customers trust us with their building needs.
            </p>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={28}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-row gutter-15 clearfix">
            {this.state.iconbox.map((data) => (
              <div className="col span_1_of_4" key={data.id}>
                <div
                  className="themesflat-content-box clearfix"
                  data-margin="0 0px 0 0px"
                  data-mobilemargin="0 0 0 0"
                >
                  <div className="themesflat-icon-box icon-top align-center has-width w95 circle light-bg accent-color border-light padding-inner pd33 style-1 clearfix">
                    <div className="icon-wrap">
                      <i className={data.icon} />
                    </div>
                    <div className="text-wrap">
                      <h5 className="heading">
                        <Link to="#">{data.title}</Link>
                      </h5>
                      <div className="sep clearfix" />
                      <p className="sub-heading">{data.text}</p>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={45}
            data-mobile={35}
            data-smobile={35}
          />
          {/* <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">OUR JOURNEY</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={24}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-row separator drank clearfix">
            {this.state.history.map((data) => (
              <div className="span_1_of_6 separator-solid" key={data.id}>
                {data.content.map((contents) => (
                  <div className={contents.classnames} key={contents.id}>
                    <div className="title">{contents.year}</div>
                    <p>{contents.text}</p>
                  </div>
                ))}
              </div>
            ))}
          </div> */}
          <div
            className="themesflat-spacer clearfix"
            data-desktop={38}
            data-mobile={35}
            data-smobile={35}
          />
          <div className="themesflat-headings style-2 clearfix">
            <h2 className="heading">OUR CORE VALUES</h2>
            <div className="sep has-width w80 accent-bg clearfix" />
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={35}
            data-mobile={35}
            data-smobile={35}
          />
          <div
            className="themesflat-content-box"
            data-margin="0 0 0 0"
            data-mobilemargin="0 0 0 0"
          >
            <div className="themesflat-accordions style-3 has-icon icon-left iconstyle-2 our-background clearfix">
              {this.state.accordions.map((data) => (
                <div className={data.classnames} key={data.id}>
                  <h3 className="accordion-heading">
                    <span className="inner">{data.title}</span>
                  </h3>
                  <div className="accordion-content">
                    <div>{data.text}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
          <div
            className="themesflat-spacer clearfix"
            data-desktop={80}
            data-mobile={60}
            data-smobile={60}
          />
        </div>
      </div>
    );
  }
}

export default SiteContent;
